import React, { ReactElement } from "react";
import { 
    GoogleIcon,
    Gold,
    StoreButton,
    StoreText,
    StoreTextSmall,
    StoreTextStrong,
    Wrapper,
    Section
} from "./styled";

export const AboutPage: React.FC = (): ReactElement => {
    return (
        <Wrapper>
            <Section>
                <Gold>Plumme</Gold> — пространство социальных связей, объединяющее людей через клубы по интересам для досуга, нетворкинга, встреч и общения в Москве и других крупных городах России.
            </Section>
            <br />
            <Section>
                Находите тех, кто разделяет вашу страсть, и становитесь частью чего-то большего:<br /><br/>
                <ul>
                    <li> - находите клубы по вашим интересам и становитесь их резидентом, чтобы иметь доступ к сообществу и возможностям клуба;</li><br/>
                    <li> - посещайте мероприятия клубов и находите себе компанию: приглашайте интересующих вас людей на совместный досуг;</li><br/>
                    <li> - расширяйте свои связи: присоединяйтесь к обсуждениям внутри клубов, делитесь опытом, мнениями и заводите новые знакомства;</li><br/>
                    <li> - развивайте ваш бренд: заполняйте свой профиль и заявляйте о себе: инструменты приложения помогут вам стать заметнее в интересующей вас сфере.</li><br/>
                </ul>
            </Section>
            <br />
            <Section>
                В клубах Plumme только настоящие и активные люди: каждый пользователь проходит ручную модерацию перед тем, как стать частью сообщества.<br /><br/>
                Присоединяйтесь к клубам, соответствующим вашим интересам и ценностям – насыщайте свою жизнь новыми впечатлениями и качественными связями.
            </Section>
            <StoreButton href="/">
                <GoogleIcon
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    fillRule="evenodd"
                    d="M5 8a4 4 0 1 1 7.796 1.263l-2.533 2.534A4 4 0 0 1 5 8Zm4.06 5H7a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h2.172a2.999 2.999 0 0 1-.114-1.588l.674-3.372a3 3 0 0 1 .82-1.533L9.06 13Zm9.032-5a2.907 2.907 0 0 0-2.056.852L9.967 14.92a1 1 0 0 0-.273.51l-.675 3.373a1 1 0 0 0 1.177 1.177l3.372-.675a1 1 0 0 0 .511-.273l6.07-6.07a2.91 2.91 0 0 0-.944-4.742A2.907 2.907 0 0 0 18.092 8Z"
                    clipRule="evenodd"
                  />
                </GoogleIcon>

                  <StoreText>
                    <StoreTextSmall>Регистрация</StoreTextSmall>
                    <StoreTextStrong>здесь</StoreTextStrong>
                  </StoreText>
            </StoreButton>
        </Wrapper>
    );
};